import { io } from 'socket.io-client';

const SOCKET_URL = "http://52.64.216.143:8000";
// const SOCKET_URL = 'http://localhost:8000'

const socket = io(SOCKET_URL, {
    path: "/socket.io/",
    transports: ["websocket", "polling"],
    withCredentials: true
});

//  Connection status logs
socket.on("connect", () => {
    console.log("MySpy connected to backend:");
});

socket.on("disconnect", (reason) => {
    console.warn("MySpy disconnected from backend:", reason);
});

socket.on("connect_error", (err) => {
    console.error("MySpy connection error:", err.message);
});

export default socket;


